// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseScheduledTableHeader_root__UMz7Q","heading":"CoursePauseScheduledTableHeader_heading__Yc9h7"};